<script>
 import {sgettext} from '../i18n.js';
 export let title = 'title';
 export let id = 'modal';
 export let onCancel = () => console.log('Cancel clicked.');
 export let onSave = () => console.log('Save clicked.');
 export let backdrop = true;
 export let large = false;
</script>

<style>
  .bs3 :global(form){
    font-size: 14px;
  }

  .bs3 :global(form .label) {
    font-size: 16px;
    text-align: left;
    color: #454545;
    white-space: pre-wrap;
    font-weight: normal;
  }

  .modal-footer button {
    margin-left: 10px;
  }
</style>


<div class="bs3 modal fade" id={id} tabindex="-1" role="dialog" data-backdrop={backdrop}>
  <div class={`modal-dialog ${large ? 'modal-lg' : ''}`} role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title">{title}</h4>
      </div>
      <div class="modal-body">
        <slot name="body"></slot>
      </div>
      <div class="modal-footer">
        <slot name="footer">
          <button
            type="button"
            class="btn btn-primary"
            on:click={onCancel}
            data-dismiss="modal">{sgettext('$$CANCEL$$')}</button>
          <button
            type="button"
            on:click={onSave}
            class="btn btn-default">{sgettext('$$SAVE$$')}</button>
        </slot>
      </div>
    </div>
  </div>
</div>
